import * as types from './mutation-types'

export const authGetRoles = ({ commit }) => {
  Vue2.prototype.$api.active().get('roles')
    .then((response) => {
      commit(types.AUTH_SET_ROLES, response.data.data)
    }).catch((errors) => {
      console.log(errors.response)
    })
}

export const authSMSRegister = ({ commit }, { form, route }) => {
  form.startProcessing()

  return Vue2
    .prototype
    .$api
    .public()
    .post(route, form)
    .finally(() => form.finishProcessing())
}

export const authSMSSendRequest = ({ commit }, { form, route}) => {
  form.startProcessing()

  return Vue2
    .prototype
    .$api
    .public()
    .post(route, form)
    .finally(() => form.finishProcessing())
}